import React, {useState, useEffect} from 'react';
import MetaTags from 'react-meta-tags'; 
import { Link } from 'react-router-dom'; // Added Meta Tag npm Package
import { Row, Col, Container, Card, CardBody, CardTitle, Modal, Form, Label, Input, UncontrolledTooltip, Badge } from "reactstrap"

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";

import axios from 'axios';
import * as url from 'helpers/url_helper';
import { HRConfig, TOAST_OPTIONS } from 'helpers/backend_helper';
import toastr from "toastr";
import "toastr/build/toastr.min.css";

import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory from 'react-bootstrap-table2-paginator';
import ToolkitProvider, { Search } from 'react-bootstrap-table2-toolkit';

import { Button} from "reactstrap";
import LoadingOverlay from 'react-loading-overlay';
LoadingOverlay.propTypes = undefined
import ClimbingBoxLoader from 'react-spinners/ClimbingBoxLoader';

    const Companies = () => {

        toastr.options = TOAST_OPTIONS;

        const [modal_users, setmodal_users] = useState(false);
        const [isEdit, setIsEdit] = useState(false);
        const [usersList, setUsersList] = useState(null);
        const [levels, setLevels] = useState(["Administrator","System user"]);
        const [user, setUser] = useState(null);
        const [isloading, setIsloading] = useState(false)

        const [id, setId] = useState('')
        const [companyName, setcompanyName] = useState('')
        const [active, setactive] = useState('')

        const removeBodyCss = () => {
            document.body.classList.add("no_padding");
        }
        const tog_users = () => {
        setmodal_users(!modal_users);
        removeBodyCss();
        }

        const fetchData = () => {
          setIsloading(true)
          axios.get(url.COMPANIES, HRConfig).then((r)=>{ 
            setUsersList(r.data); setIsloading(false) 
          }).catch((e)=>{  console.log(e); setIsloading(false) });
        }
        
        useEffect(() => {
         fetchData();
        },[]);

        const handleOptionChange = (event) => {
          const selectedValues = Array.from(event.target.selectedOptions, (option) => option.value);
          setSelectedModules(selectedValues);
        };
    
        const handleAddUser = () => {  
          if(companyName.trim().length < 3){
            toastr.error('Enter staff name')
          }else if(title.trim().length < 1){
            toastr.error('Enter staff title')
          }else if(email.trim().length < 4){
            toastr.error('Enter staff email address')
          }else{
            const obj = JSON.parse(localStorage.getItem("authMildUser"));
            if (isEdit) {
                    const data = {
                        "companyName" : companyName,
                        "middleName": middleName,
                        "lastName"  : lastName,
                        "gender"    : gender,
                        "title"     : title,
                        "changePass": changePass,
                        "phone"     : phone,
                        "email"     : email,
                        "username"  : username,
                        "level"     : category,
                        "staffNo"   : staffNo,
                        "uuId"      : obj.id,
                        "uuName"    : obj.username,
                        "action"    : 'edit'
                    }
                    setIsloading(true)
                    axios.post(url.STAFF, JSON.stringify(data), HRConfig)
                    .then((r)=>{
                        
                    if(r.data.status == '0'){
                        toastr.error(r.data.message); 
                    }else{
                        toastr.success(r.data.message); 
                        fetchData();
                        tog_users();
                        clearData();
                    }
                    })
                    .catch((e)=>{
                        console.log(e);
                    });
            }else{
                    const data = {
                      "companyName" : companyName,
                      "middleName": middleName,
                      "lastName"  : lastName,
                      "gender"    : gender,
                      "title"     : title,
                      "changePass": "Yes",
                      "phone"     : phone,
                      "email"     : email,
                      "username"  : username,
                      "level"     : category,
                      "staffNo"   : staffNo,
                      "uuId"      : obj.id,
                      "uuName"    : obj.username,
                      "action"    : 'add'
                    }
                    setIsloading(true)
                    axios.post(url.STAFF, JSON.stringify(data), HRConfig)
                    .then((r)=>{
                    if(r.data.status == '0'){
                        toastr.error(r.data.message); 
                    }else{
                        toastr.success(r.data.message); 
                        fetchData();
                        tog_users();
                        clearData()
                    }
                    })
                    .catch((e)=>{
                    console.log(e);
                    });  
            }
          }
        }
        
        const handleClickEdit = (row) => {
          tog_users(); 
          setIsEdit(true);
          setcompanyName(row.companyName)
          setactive(row.active)
        }
        const clearData = () =>{
          setIsEdit(false);
          setcompanyName('')
          setactive('')
        }
        const handleClickAdd = () => { 
          setIsEdit(false);
          clearData() 
          tog_users(); 
        }

        const { SearchBar } = Search;
        const columns = [
          {
          dataField: 'companyName',
          text: 'Company Name',
          sort: true
        },
        {
          dataField: 'active',
          text: 'Active',
          sort: true
        },
        {
          dataField: "",
          isDummyField: true,
          text: "",
          formatter: actionFormatter
        }];

        const defaultSorted = [{
          dataField: 'companyName',
          order: 'asc'
        }];
        function statusFormatter(cellContent, row) {
          if (row.status == "Active") {
            return (
              <div>
                  <Badge className="me-2 bg-success">
                  { cellContent }
                  </Badge>
              </div>
            );
          }else{
            return (
              <div>
                  <Badge className="me-2 bg-danger">
                  { cellContent }
                  </Badge>
              </div>
            );
          }
        }
        function actionFormatter(cellContent, row){
          return(
            <>
            <Button
                  type="button"
                  color="info"
                  className="btn-sm btn-rounded"
                  onClick={() => { handleClickEdit(row); }}
                >
                  Details
            </Button>
          </>
          )
        }

        return (
            <>
            <LoadingOverlay
                active={isloading}
                spinner={<ClimbingBoxLoader />}
                text='Please wait...'
                >
                <div className="page-content">
                    <MetaTags>
                    <title>Companies | BRIDGE</title>
                    </MetaTags>
                    <Container fluid={true}>
                        <Breadcrumbs title="User Management" breadcrumbItem="Companies" />


                        <Row>


                            <Col lg="12">
                            <Card>
                                <CardBody>
                                <CardTitle className="mb-4">&nbsp;</CardTitle>

                                
                                <Modal
                                  isOpen={modal_users}
                                  toggle={() => {
                                    tog_users();
                                  }}
                                  centered
                                >
                                  <div className="modal-header">
                                    <h5 className="modal-title mt-0" id="myModalLabel">{ isEdit ? 'Edit Company ': 'Add Company' }</h5>
                                    <button
                                      type="button"
                                      onClick={() => {
                                        setmodal_users(false);
                                      }}
                                      className="close"
                                      data-dismiss="modal"
                                      aria-label="Close"
                                    >
                                      <span aria-hidden="true">&times;</span>
                                    </button>
                                  </div>
                                  <div className="modal-body">
                                    
                                  <div className="row mb-2">
                                      <Label
                                        htmlFor="horizontal-email-Input"
                                        className="col-sm-3 col-form-label"
                                      >
                                        Company Name
                                      </Label>
                                      <Col sm={12}>
                                        <Input
                                          type="text"
                                          className="form-control" 
                                          value={companyName}
                                          onChange={(e)=>setcompanyName(e.target.value)}
                                        />
                                      </Col>
                                    </div>
                                    <div className="row mb-2">
                                      <Label
                                        htmlFor="horizontal-email-Input"
                                        className="col-sm-3 col-form-label"
                                      >
                                        Active
                                      </Label>
                                      <Col sm={12}>
                                        <Input
                                          type="text"
                                          className="form-control" 
                                          value={active}
                                          onChange={(e)=>setactive(e.target.value)}
                                        />
                                      </Col>
                                    </div>
                                </div>
                                  <div className="modal-footer">
                                    <button
                                      type="button"
                                      onClick={() => {
                                        tog_users();
                                      }}
                                      className="btn btn-danger "
                                      data-dismiss="modal"
                                    >
                                      Close
                                    </button>
                                    {/* <button
                                      type="button"
                                      className="btn btn-success "
                                      onClick = {()=>{handleAddUser()}}
                                    >
                                      Save...
                                    </button> */}
                                  </div>
                                </Modal>

                                {usersList && (usersList.length > 0) && (
                                    <>
                                    <ToolkitProvider
                                      keyField="no"
                                      data={ usersList }
                                      columns={ columns }
                                      search
                                    >
                                      { toolkitProps => (
                                          <React.Fragment>
                           
                                            {/* <Row className='mb-5'>
                                                  <Col lg={8} className='mb-2'>
                                                    <div  className="rounded bg-light d-grid gap-2">
                                                      <SearchBar {...toolkitProps.searchProps} className="form-control bg-transparent border-0 searchTm m-0" />
                                                    </div>
                                                  </Col>
                                            
                                                  <Col lg={4}> 
                                                  <div className="d-grid gap-2">
                                                      <Button
                                                        color='primary'
                                                        className="btn"
                                                        onClick={() => { handleClickAdd() }}
                                                      >
                                                        <i className="mdi mdi-plus me-1" />
                                                        Add system user
                                                      </Button>
                                                    </div>
                                                  </Col>
                                                </Row> */}
                                            <Row>
                                              <Col xl="12">
                                                <div className="table-responsive">
                                            
                                                <BootstrapTable 
                                                  keyField='no' 
                                                  data={ usersList } 
                                                  columns={ columns } 
                                                  striped
                                                  //hover
                                                  condensed
                                                  bordered={ false }
                                                  noDataIndication="No Records" 
                                                  defaultSorted={ defaultSorted }
                                                  classes={ "table align-middle table-wrap table-check" }
                                                    {...toolkitProps.baseProps}
                                                  />
                                            </div>
                                            </Col>
                                            </Row>
                                            </React.Fragment>
                                            
                                      )
                                    }
                                  </ToolkitProvider>

                                    </>
                                )}
                                {usersList && (usersList.length < 1) && (
                                    <div className="text-center">
                                        <div className="mb-4">
                                        <i className="mdi mdi-flask-empty-minus-outline text-danger display-4" />
                                        </div>
                                        <div>
                                        <h5>No Users Found</h5>
                                        <p className="text-muted">
                                                
                                        </p>
                                        </div>
                                    </div>

                                )}
                                </CardBody>
                            </Card>
                            </Col>
                        </Row>

                        
                           

                    </Container>
                </div>
                </LoadingOverlay>
            </>
        );
    }

export default Companies;